import {
    InspectionGroup,
    translateInspectionGroup,
} from 'aos-services/src/services/tasks/types/task/InspectionGroup'
import { Icon, Pressable, Text } from 'aos-ui-universal'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { inspectionGroupIcons } from '../../../../utils'
import { taskChip } from '../../taskChip'
import { InspectionSelectedCounter } from './InspectionSelectedCounter'

const inspectionChipLayout =
    'relative min-h-[80px] flex-col items-center justify-end gap-1 px-2 py-2'

interface InspectionTypeIconRendererProps {
    isSelected: boolean
    group: InspectionGroup
    onSelect(): void
    selectedInspectionsCounter: number
    inspectionTotalNumber: number
}

export const InspectionTypeIconRenderer: FC<InspectionTypeIconRendererProps> = ({
    isSelected,
    onSelect,
    group,
    inspectionTotalNumber,
    selectedInspectionsCounter,
}) => {
    const { t: translate } = useTranslation()
    return (
        <Pressable
            accessibilityRole='radio'
            accessibilityState={{ selected: isSelected }}
            onPress={onSelect}
            className={taskChip({ isSelected, class: inspectionChipLayout })}
        >
            {selectedInspectionsCounter > 0 && (
                <InspectionSelectedCounter
                    selectedInspectionsCounter={selectedInspectionsCounter}
                    inspectionTotalNumber={inspectionTotalNumber}
                />
            )}
            <Icon
                as={inspectionGroupIcons[group]}
                size={24}
                className={isSelected ? 'text-content-on-primary' : 'text-content-default'}
            />
            <Text
                size='body'
                tone={isSelected ? 'on-primary' : 'default'}
                numberOfLines={2}
                className='text-center'
            >
                {translateInspectionGroup(translate)(group)}
            </Text>
        </Pressable>
    )
}
